module.exports = __webpack_public_path__ + "img/st.434963fc.svg";